import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import useBrowserNotifications from '@/hooks/use-browser-notifications';
import useChatWidgetOpen from './use-chat-widget-open';
import type { ChatTurnCompleteEvent } from './use-chat-ws';
const MIN_DONE_TURN_MS = 5000;
const useTurnCompleteNotification = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "floatingChat.notifications"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t0);
  const {
    notify
  } = useBrowserNotifications();
  const {
    open
  } = useChatWidgetOpen();
  let t1;
  if ($[1] !== notify || $[2] !== open || $[3] !== t) {
    t1 = event => {
      if (event.wasInterrupted) {
        return;
      }
      const tag = `percy-${event.sessionId ?? "chat"}`;
      if (event.hasPendingQuestion) {
        notify(t(_temp), {
          body: t(_temp2),
          tag,
          onClick: open
        });
        return;
      }
      if (event.isError) {
        notify(t(_temp3), {
          body: t(_temp4),
          tag,
          onClick: open
        });
        return;
      }
      if (event.hasRunningJourneys) {
        return;
      }
      if (event.durationMs !== undefined && event.durationMs < MIN_DONE_TURN_MS) {
        return;
      }
      notify(t(_temp5), {
        body: t(_temp6),
        tag,
        onClick: open
      });
    };
    $[1] = notify;
    $[2] = open;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default useTurnCompleteNotification;
function _temp($) {
  return $.needsInputTitle;
}
function _temp2($_0) {
  return $_0.needsInputBody;
}
function _temp3($_1) {
  return $_1.errorTitle;
}
function _temp4($_2) {
  return $_2.errorBody;
}
function _temp5($_3) {
  return $_3.doneTitle;
}
function _temp6($_4) {
  return $_4.doneBody;
}